import React from 'react';
import { Button, Result } from 'antd';
import {useNavigate} from "react-router-dom"

const NotFund: react.Fc = ()=>{
    const navigate = useNavigate()
    
    const GotoLogin = ()=>{
        navigate("/login")
    }
    return (
        <Result
        status="warning"
        title="There are some problems with your operation."
            extra={
            <Button onClick={GotoLogin} type="primary" key="console">
                Go Login
            </Button>
            }
        />
    )
}

export default NotFund